import * as tslib_1 from "tslib";
import { EntityType, DataProperty, DataType, Validator } from 'breeze-client';
import { BreezeService } from '../core/breeze.service';
import { AlertsService } from '../core/alerts.service';
import { WorkSlip } from './workslip';
import { TranslateService } from '@ngx-translate/core';
import { EntityManagerService } from '../entity-manager.service';
import { WorkSlipSpendTime } from '../workslips/helpers/spend-time';
var WorkSlipsService = /** @class */ (function (_super) {
    tslib_1.__extends(WorkSlipsService, _super);
    /**
     * Creates an instance of WorkSlipsService.
     * @param {AlertsService} alertsService The service is used to display alerts.
     * @param {TranslateService} translateService The translation service.
     * @memberOf WorkSlipsService
     */
    function WorkSlipsService(alertsService, translateService, entityManagerService) {
        var _this = _super.call(this, alertsService, translateService, entityManagerService) || this;
        /**
         * Supported notifications entity types.
         * @private
         * @type {{ [key: string]: Function }
         */
        _this.registerEntityTypes = {
            WorkSlip: WorkSlip,
            SpendTime: WorkSlipSpendTime
        };
        _this.initialize('workslips');
        WorkSlipsService.entityTypes = _this.entityManager.metadataStore.getEntityTypes();
        Object.keys(_this.registerEntityTypes).forEach(function (entityType) {
            _this.metadataStore.registerEntityTypeCtor(entityType, _this.registerEntityTypes[entityType]);
        });
        _this.registerValidator('WorkSlip', 'ReceiverEmail', Validator.emailAddress());
        _this.registerValidator('WorkSlip', 'CustomerEmail', Validator.emailAddress());
        var spendTimeType = _this.metadataStore.getEntityType('SpendTime');
        spendTimeType.addProperty(new DataProperty({
            dataType: DataType.String,
            isNullable: false,
            name: 'Effort',
            nameOnServer: 'Effort'
        }));
        spendTimeType.addProperty(new DataProperty({
            dataType: DataType.String,
            isNullable: false,
            name: 'TravelTime',
            nameOnServer: 'TravelTime'
        }));
        return _this;
    }
    return WorkSlipsService;
}(BreezeService));
export { WorkSlipsService };
